import React from 'react'
import '../../App.css'

export default function Team5() {
    return <h1 className="team5">Team 5</h1>
}